var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c("DrugSearchOutsource", {
            attrs: {
              companyId: _vm.companyId,
              clearSelected: true,
              companyDrugsOnly: _vm.drugs.length > 0,
              onSelect: (drug) => _vm.addDrug(drug),
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mt-2" },
      _vm._l(_vm.drugs, function (d, i) {
        return _c("div", [
          _c("div", { staticClass: "input-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: d.title,
                  expression: "d.title",
                },
              ],
              staticClass: "form-control grow_input",
              attrs: { type: "text", disabled: "" },
              domProps: { value: d.title },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(d, "title", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm._m(0, true),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: d.requestQty,
                  expression: "d.requestQty",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: d.requestQty },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(d, "requestQty", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm._m(1, true),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: d.price,
                  expression: "d.price",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "text", disabled: "" },
              domProps: { value: d.price },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(d, "price", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-group-append" }, [
              _c("span", { staticClass: "input-group-text" }, [
                _vm._v("\n            Наличие "),
                _c("strong", [_vm._v(_vm._s(d.qty))]),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-danger",
                  on: { click: () => _vm.removeDrug(i) },
                },
                [_vm._v("x")]
              ),
            ]),
          ]),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _vm.drugs.length
      ? _c(
          "div",
          { staticClass: "text-right mt-1" },
          [
            _c("LoadingButton", {
              attrs: {
                title: "Отправить",
                loading: _vm.loading,
                color: _vm.$constants.SUCCESS_COLOR,
                onClick: () => _vm.sendRequest(),
                className: "btn btn-outline-success",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("Кол.")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "icon-fa icon-fa-rub" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }